export default __webpack_public_path__ + "static/100-ecc074a733515b514f15d04a40e36c8e.gif";